/*
 * @Descripttion:
 * @Author: voanit
 * @Date: 2020-11-06 20:40:06
 * @LastEditors: zhangxu
 * @LastEditTime: 2025-10-10 14:21:23
 */
// 3-25 新修改字典表
const date = new Date().getFullYear()
let year = []
let oldYear = []
for (let i = 0; i <= 10; i++) {
  if (i < 6) {
    year.push({
      value: date + i,
      label: `${date + i}`
    })
  }
  oldYear.push({
    value: date - i,
    label: `${date - i}`
  })
}

export default {
  //年份
  year: year,
  oldYear: oldYear,
  //充值管理
  recharge_manage: {
    agent_type: [
      { value: 1, label: '直营' },
      { value: 2, label: '合伙人' }
    ],
    online_type: [
      { value: 0, label: '线下' },
      { value: 1, label: '线上' }
    ]
  },
  //课程管理
  //年级
  grade: [],
  // 授课科目
  subjects: [
    // { label: '数学', value: 'S', code: 0 },
    // { label: '语文', value: 'Y', code: 0 },
    // { label: '英语', value: 'E', code: 0 },
    // { label: '物理', value: 'W', code: 1 },
    // { label: '化学', value: 'H', code: 1 },
    // { label: '生物', value: 'C', code: 1 },
    // { label: '政治', value: 'Z', code: 1 },
    // { label: '历史', value: 'L', code: 1 },
    // { label: '地理', value: 'D', code: 1 }
  ],
  // 课程类型
  courseType: [],
  teachingMaterial: [],
  mediaType: [
    { label: '视频', value: 0 },
    { label: '音频', value: 0 }
  ],
  //创建来源
  sourceArray: [
    { label: '全部', value: '' },
    { label: '自主创建', value: 1 },
    { label: '企业微信', value: 0 }
  ],
  status: [
    { label: '全部', value: '' },
    { label: '已上架', value: 1 },
    { label: '未上架', value: 0 }
  ],
  switchStatus: [
    { label: '全部', value: '' },
    { label: '已开通', value: 1 },
    { label: '已关闭', value: 0 }
  ],
  serviceTypeList: [],
  memberTypeList: [],
  sliceStatus: [
    { label: '已发布', value: 1 },
    { label: '未发布', value: 0 }
  ],
  courseStatus: [
    { label: '全部', value: '' },
    { label: '已上架', value: 1 },
    { label: '未上架', value: 0 },
    { label: '待下架', value: 2 }
  ],
  chapterStatus: [
    { label: '全部', value: '' },
    { label: '已上架', value: 1 },
    { label: '未上架', value: 0 },
    { label: '预上架', value: 2 }
  ],
  teacherList: [],
  // 门店状态
  agentStatus: [
    { label: '开通中', value: 1 },
    { label: '已关闭', value: 0 }
  ],
  // 门店类型
  agentType: [
    { label: '直营', value: 1 },
    { label: '合伙人', value: 2 }
  ],
  // 对账状态
  financeStatus: [
    { label: '已对账', value: 1 },
    { label: '待对账', value: 2 }
  ],
  articleCategory: [],
  // 门店列表
  schoolList: [],
  // 省
  provinceList: [],
  // 市
  cityList: [],
  // 套餐类型
  mealTypeList: [],
  dayOptions: [
    {
      value: 30,
      label: '30天'
    },
    {
      value: 60,
      label: '60天'
    },
    {
      value: 90,
      label: '90天'
    },
    {
      value: 180,
      label: '180天'
    },
    {
      value: 365,
      label: '365天'
    }
  ],
  showZeroProductOrder: [
    {
      value: 0,
      label: '不显示'
    },
    {
      value: 1,
      label: '显示'
    }
  ],
  difficulty: [],
  // 退费状态
  refundStatus: [],
  staffStatus: [],
  // 订单状态
  orderStatus: [],
  orderStatusTjw: [],
  orderServiceStatus: [],
  channelOrderServiceStatus: [],
  // 订单类型
  orderType: [],
  //支付方式
  paymentTypeList: [],
  videoPriceType: [],
  // messageTypes: [
  //   {
  //     value: 1,
  //     label: '课程更新'
  //   },
  //   {
  //     value: 2,
  //     label: '系统公告'
  //   },
  //   {
  //     value: 0,
  //     label: '其他'
  //   }
  // ],
  receiveType: [
    {
      value: 1,
      label: '门店通知'
    },
    {
      value: 2,
      label: '学生端'
    }
  ],
  messageTypesAll: [
    // {
    //   value: 1,
    //   label: '课程更新',
    //   receiveType: 2
    // },
    // {
    //   value: 2,
    //   label: '系统公告',
    //   receiveType: 2
    // },
    // {
    //   value: 0,
    //   label: '其他',
    //   receiveType: 2
    // },
    // {
    //   value: 5,
    //   label: 'IT产品更新',
    //   receiveType: 1
    // },
    // {
    //   value: 6,
    //   label: '教学产品更新',
    //   receiveType: 1
    // },
    // {
    //   value: 7,
    //   label: '官方公告',
    //   receiveType: 1
    // }
  ],
  recvTypes: {
    0: '所有门店会员',
    1: '全部中学会员',
    2: '指定会员',
    3: '指定门店'
  },
  recvTypesAll: {
    0: '所有门店会员',
    1: '全部中学会员',
    2: '指定会员',
    3: '指定门店',
    7: '全部门店',
    8: '指定门店'
  },
  gradePeriodList: [],
  subjectCategoryList: [
    { label: '全科', value: 0 },
    { label: '单科', value: 1 }
  ],
  vipStatusArr: [],
  subjectModels: [],
  handleReasons: {
    1: '无意义内容',
    2: '不良或负面内容',
    3: '辱骂内容',
    4: '刷屏',
    5: '其他'
  },
  deductSilences: {
    12: '禁言12小时',
    72: '禁言3天',
    876000: '禁止发布弹幕'
  },
  superMemberProductList: [],
  cityLevel: [],
  goodsClassify: [],
  classificationList: [],
  orderServiceTypeList: [
    { dictValue: 0, dictName: '退货' },
    { dictValue: 1, dictName: '换货' },
    { dictValue: 2, dictName: '维修' },
    { dictValue: 3, dictName: '退款' }
  ],
  difficultyLayeredList: [],
  diffList: [], //试题难度
  qTypeList: [], //试题题型
  auditStatus: [
    //审校状态
    { dictValue: 0, dictName: '未审校' },
    { dictValue: 1, dictName: '已审校' }
  ],
  auditStatusFirst: [
    //审校状态
    { dictValue: 0, dictName: '未审校' },
    { dictValue: 1, dictName: '已审校' },
    { dictValue: 2, dictName: '未通过' }
  ],
  useStatus: [
    //审校状态
    { dictValue: 0, dictName: '未使用' },
    { dictValue: 1, dictName: '已使用' }
  ],
  quesLabelList: [],
  quesSourceList: [],
  mediaTypeList: {
    0: '小测听力音频',
    1: '练习听力音频',
    2: '老师讲义pdf',
    3: '老师讲义word',
    4: '老师小测pdf',
    5: '老师小测word',
    6: '老师练习pdf',
    7: '老师练习word',
    8: '学生讲义pdf',
    9: '学生讲义word',
    10: '学生小测pdf',
    11: '学生小测word',
    12: '学生练习pdf',
    13: '学生练习word',
    20: '课件ppt资料'
  },
  problemType: [
    {
      code: 11,
      label: '课程讲解错误'
    },
    {
      code: 12,
      label: '讲义小测练习文档错误'
    },
    {
      code: 13,
      label: '课程讲解错误'
    },
    {
      code: 14,
      label: '小测练习讲解错误'
    },
    {
      code: 21,
      label: '课程播放问题'
    },
    {
      code: 22,
      label: '小测练习播放问题'
    },
    {
      code: 31,
      label: '主讲视频超纲'
    },
    {
      code: 32,
      label: '小测练习题超纲'
    },
    {
      code: 41,
      label: '课程更新进度'
    },
    {
      code: 42,
      label: '小测练习更新进度'
    },
    {
      code: 51,
      label: '其他问题'
    }
  ],
  userAuthLevelList: [],
  agtStatusList: [
    {
      label: '咨询期',
      value: 3,
      showType: 2
    },
    {
      label: '总部认为不合适',
      value: 4,
      showType: 2
    },
    {
      label: '代理商不合作',
      value: 5,
      showType: 2
    },
    {
      label: '意向期',
      value: 2,
      showType: 2
    },
    {
      label: '合作中',
      value: 1,
      showType: 1
    },
    {
      label: '已解约',
      value: 0,
      showType: 1
    }
  ],
  contractType: [
    {
      label: '续签单店',
      value: 1
    },
    {
      label: '续签区域代理',
      value: 2
    },
    {
      label: '扩签单店',
      value: 3
    },
    {
      label: '解约申请',
      value: 4
    },
    {
      label: '区域代理申请开店',
      value: 5
    },
    {
      label: '升级区域代理',
      value: 6
    },
    {
      label: '地址变更',
      value: 7
    },
    {
      label: '区域合作伙伴降级',
      value: 8
    }
  ],
  stopType: [
    {
      label: '总部筛选淘汰',
      value: 1
    },
    {
      label: '未完成考核任务',
      value: 2
    },
    {
      label: '代理商主动解约',
      value: 3
    }
  ],
  // 合同名称与续签类型映射
  contractNameToTypeMap: {
    单店申请续签合同: '续签单店',
    区域代理申请续签合同: '续签区域代理',
    单店扩店申请: '扩签单店',
    申请解约: '解约申请',
    区域代理申请开通新门店: '区域代理申请开店',
    单店升级区域代理申请: '升级区域代理',
    地址变更: '地址变更',
    区域代理降级单店: '区域合作伙伴降级'
  },
  expandType: [
    {
      label: '全部',

      value: ''
    },
    {
      label: '新签',

      value: 1
    },

    {
      label: '扩店',

      value: 2
    }
  ]
}
